import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

import styles from './styles.module.scss';

import useModal from '@/hooks/util/useModal';
import { colors } from '@/Themes/Colors';
import PurpleButton from '../../shared/purple-button/PurpleButton';

export interface IAlertProps {
  open: boolean;
  onConfirm(): void;
  closeOnDimerClick?: boolean;
  closeIcon?: boolean;
  children?: ReactNode;
  isAlert?: boolean;
  confirmText?: string | ReactNode;
}

function Alert({
  open,
  closeIcon = true,
  closeOnDimerClick = true,
  children,
  onConfirm,
  isAlert = false,
  confirmText = <b>Sair</b>,
}: IAlertProps) {
  const Modal = useModal({ maxHeight: undefined });

  if (!open) return null;

  return createPortal(
    <Modal
      onClose={onConfirm}
      open={open}
      closeOnDimerClick={closeOnDimerClick}
      closeIcon={closeIcon}
      width="28.125rem"
      noBorder
      className={styles.alertContainer}
    >
      {isAlert && (
        <div className={styles.alertIcon}>
          <FontAwesomeIcon
            icon={faExclamationCircle}
            color={colors.brand10}
            size="4x"
          />
          <h4>
            <b>Atenção</b>
          </h4>
        </div>
      )}

      {children}

      <div className={styles.actions}>
        <PurpleButton onClick={onConfirm}>{confirmText}</PurpleButton>
      </div>
    </Modal>,
    document.body,
  );
}

export default Alert;
